import React from 'react'

import styled from '@emotion/styled'
import { mq, black02, hoverFade } from '../../_style'
import { Link } from 'gatsby';
import imgLogo from '../../assets/imgs/img-global-logo.svg';

const Container = styled.footer`
  letter-spacing: .1em;
  .common-footer {
    font: 500 14px/1.5 "Noto Sans Japanese", "游ゴシック体", YuGothic, "YuGothic M", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  }
  .common-footer a[target="_blank"]:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    background: url(/common/images/ico-blank.svg) center center no-repeat;
  }
  .common-footer a[target="_blank"]:after {
    height: 10px;
    margin: 0 0 0 5px;
    width: 10px;
  }
  .common-footer-nav a:hover {
    color: #fff;
  }
  .common-footer-menu {
    background: #f1f5f6;
  }
  .common-footer-menu > .inner {
    display: flex;
    justify-content: center;
  }
  .common-footer {
  background: #424242;
  color: #fff;
  }
  .common-footer .inner:after {
    clear: both;
    content: "";
    display: block;
    height: 0;
    overflow: hidden;
  }
  .common-footer-menu {
    background: #f1f5f6;
  }
  .common-footer-menu a:link,
  .common-footer-menu a:visited,
  .common-footer-menu a:hover,
  .common-footer-menu a:active {
    color: #6e6e6e;
  }
  .common-footer-menu > .inner {
    display: flex;
    display: -ms-flex;
    justify-content: center;
  }

  .common-footer-menu-box {
    width: 16%;
  }

  .common-footer-menu-list {
    font-size: 14px;
    margin-top: 25px;
  }

  .common-footer-menu-list:first-of-type {
    margin-top: 0;
  }

  .common-footer-menu-underlayer li {
    font-size: 12px;
    margin-top: 10px;
  }

  .common-footer-menu-underlayer li:before {
    color: #3e3e3e;
    content: "- ";
  }

  .common-footer-nav {
    font-size: 0;
  }

  .common-footer-nav-list {
    display: inline-block;
  }

  .common-footer-nav a {
    color: #fff !Important;
  }
  .common-footer-copyright {
    letter-spacing: .09em;
  }
  ${mq.sp} {
    .common-footer {
      font: 500 14px/1.5 "Noto Sans Japanese", "游ゴシック体", YuGothic, "YuGothic M", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
    }
    .common-footer a[target="_blank"]:after {
      background-size: 8px;
      height: 8px;
      margin: 0 0 0 5px;
      width: 8px;
      right: 8px;
    }
  }
  @media screen and (min-width: 1170px) {
    .common-footer .inner {
      box-sizing: content-box;
      margin: 0 auto;
      max-width: 1180px;
      padding: 0 50px;
    }
    .common-footer-menu {
      padding: 50px 0 50px;
    }
    .common-footer-nav {
      padding: 56px 0 0;
      text-align: center;
    }
    .common-footer-nav-list {
      font-size: 12px;
    }
    .common-footer-nav-list:before {
      content: "|";
      display: inline-block;
      margin: 0 1em;
    }
    .common-footer-nav-list:first-of-type:before {
      content: "";
      display: none;
    }
    .common-footer-copyright {
      font-size: 10px;
      padding: 20px 0 56px;
      text-align: center;
    }
    .common-footer-type2 .common-footer-copyright {
      padding-bottom: 20px;
    }
  }
  @media screen and (max-width: 1169px) {
    .common-footer > .inner {
      padding: 32px 0 0;
    }
    .common-footer-menu {
      display: none;
    }
    .common-footer-nav {
      padding: 0 16px;
      text-align: center;
    }
    .common-footer-nav-list {
      font-size: 11px;
      margin: 1em 5px 0;
    }
    .common-footer-copyright {
      font-size: 12px;
      padding: 28px 0 32px;
      text-align: center;
    }

    .common-footer-type2 > .inner {
      padding: 0;
    }
    .common-footer-type2 .common-footer-copyright {
      padding: 10px 0;
    }
  }
`
export default class GlobalFooter extends React.Component {
  render() {
    return(
      <Container>
        <div className="common-footer">
          <nav className="common-footer-menu">
            <div className="inner">
              <ul className="common-footer-menu-box footer-menu-cat">
                <li className="common-footer-menu-list"><a href="/pest-control/index.html">虫ケア用品</a>
                  <ul className="common-footer-menu-underlayer">
                    <li className="common-footer-menu-underlayer-list"><a href="/pest-control/fly-mosquito/index.html">ハエ・蚊</a></li>
                    <li className="common-footer-menu-underlayer-list"><a href="/pest-control/fruit-fly/index.html">コバエ</a></li>
                    <li className="common-footer-menu-underlayer-list"><a href="/pest-control/insect-repellent/index.html">虫よけ</a></li>
                    <li className="common-footer-menu-underlayer-list"><a href="/pest-control/cockroach/index.html">ゴキブリ</a></li>
                    <li className="common-footer-menu-underlayer-list"><a href="/pest-control/mite/index.html">ダニ</a></li>
                    <li className="common-footer-menu-underlayer-list"><a href="/pest-control/ant/index.html">アリ</a></li>
                    <li className="common-footer-menu-underlayer-list"><a href="/pest-control/bee/index.html">ハチ</a></li>
                    <li className="common-footer-menu-underlayer-list"><a href="/pest-control/spider/index.html">クモ</a></li>
                    <li className="common-footer-menu-underlayer-list"><a href="/pest-control/centipede/index.html">ムカデ</a></li>
                    <li className="common-footer-menu-underlayer-list"><a href="/pest-control/lice/index.html">シラミ</a></li>
                    <li className="common-footer-menu-underlayer-list"><a href="/pest-control/various-bugs/index.html">その他害虫</a></li>
                    <li className="common-footer-menu-underlayer-list"><a href="/pest-control/mouse/index.html">ネズミ</a></li>
                    <li className="common-footer-menu-underlayer-list"><a href="/pest-control/mothball/index.html">防虫剤</a></li>
                  </ul>
                </li>
              </ul>
              <ul className="common-footer-menu-box footer-menu-cat">
                <li className="common-footer-menu-list"><a href="/bath-agent/index.html">入浴剤</a></li>
                <li className="common-footer-menu-list"><a href="/oral-care/index.html">オーラルケア</a></li>
                <li className="common-footer-menu-list"><a href="/air-freshener/index.html">消臭芳香剤</a></li>
                <li className="common-footer-menu-list"><a href="/cleaning/index.html">お掃除用品</a></li>
                <li className="common-footer-menu-list"><a href="/personal-care/index.html">衛生用品</a></li>
              </ul>
              <ul className="common-footer-menu-box footer-menu-cat">
                <li className="common-footer-menu-list"><a href="/gardening/index.html">園芸用品</a>
                  <ul className="common-footer-menu-underlayer">
                    <li className="common-footer-menu-underlayer-list"><a href="/gardening/plant-protective/index.html">農薬</a></li>
                    <li className="common-footer-menu-underlayer-list"><a href="/gardening/fertilizer/index.html">切り花延命剤</a></li>
                    <li className="common-footer-menu-underlayer-list"><a href="/gardening/weeds/index.html">雑草対策</a></li>
                    <li className="common-footer-menu-underlayer-list"><a href="/gardening/pest-control/index.html">害虫対策</a></li>
                    <li className="common-footer-menu-underlayer-list"><a href="/gardening/insect-repellent/index.html">虫よけ</a></li>
                    <li className="common-footer-menu-underlayer-list"><a href="/gardening/vermin/index.html">動物忌避</a></li>
                  </ul>
                </li>
                <li className="common-footer-menu-list"><a href="/other/index.html">その他</a></li>
              </ul>
              <ul className="common-footer-menu-box">
                <li className="common-footer-menu-list"><a href="/brands/index.html">ブランド一覧</a></li>
                <li className="common-footer-menu-list"><a href="/new-products/index.html">新製品</a></li>
                <li className="common-footer-menu-list"><a href="/campaign/index.html">キャンペーン・<br />スペシャルコンテンツ</a></li>
                <li className="common-footer-menu-list"><a href="/cm/index.html">CMライブラリ</a></li>
              </ul>
              <ul className="common-footer-menu-box">
                <li className="common-footer-menu-list"><a href="/store/" target="_blank">取扱店検索</a></li>
                <li className="common-footer-menu-list"><a href="/online-store/index.html">オンラインストア</a></li>
                <li className="common-footer-menu-list"><a href="/info/index.html">お知らせ</a></li>
                <li className="common-footer-menu-list"><a href="/support/index.html">お問い合わせ</a></li>
                <li className="common-footer-menu-list"><a href="/sitemap/index.html">サイトマップ</a></li>
                <li className="common-footer-menu-list"><a href="https://www.youtube.com/user/EarthChemical" target="_blank">アースチャンネル</a></li>
              </ul>
            </div>
          </nav>
          <div className="inner">
            <nav>
              <ul className="common-footer-nav">
                <li className="common-footer-nav-list"><a href="https://corp.earth.jp/jp/privacy/index.html" target="_blank">プライバシーポリシー</a></li>
                <li className="common-footer-nav-list"><a href="https://corp.earth.jp/jp/security/index.html" target="_blank">セキュリティポリシー</a></li>
                <li className="common-footer-nav-list"><a href="https://corp.earth.jp/jp/social-media/index.html" target="_blank">ソーシャルメディアポリシー</a></li>
                <li className="common-footer-nav-list"><a href="https://corp.earth.jp/jp/terms/index.html" target="_blank">サイトのご利用にあたって</a></li>
                <li className="common-footer-nav-list"><a href="https://corp.earth.jp/jp/index.html" target="_blank">企業情報サイト</a></li>
              </ul>
            </nav>
            <p className="common-footer-copyright"><small>© Earth Corporation.</small></p>
          </div>
        </div>
      </Container>
    )
  }
}
